export default __webpack_public_path__ + "static/bSVpUhEM-6dcdfc20254b7f5e9f724a1ba9fbe633.svg";